import * as types from '../const/action.types';

export function setBluetoothUsed(used) {
    return {
        type: types.SET_BLUETOOTH_USED,
        used,
    };
}



// WEBPACK FOOTER //
// ./src/actions/bluetooth.actions.js